/**
 * Dog Pilates - Main Scripts
 */

document.addEventListener('DOMContentLoaded', function() {

    // ===========================================
    // Navbar Scroll Effect
    // ===========================================
    const navbar = document.querySelector('.navbar-dogpilates .navbar');

    if (navbar) {
        const handleScroll = function() {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        };

        // Initial check
        handleScroll();

        // Listen for scroll
        window.addEventListener('scroll', handleScroll, { passive: true });
    }

    // ===========================================
    // Initialize AOS (Animate on Scroll)
    // ===========================================
    if (typeof AOS !== 'undefined') {
        AOS.init({
            duration: 800,
            once: true,
            offset: 100,
            easing: 'ease-out-cubic'
        });
    }

    // ===========================================
    // Initialize FancyBox (Lightbox)
    // ===========================================
    if (typeof Fancybox !== 'undefined') {
        Fancybox.bind("[data-fancybox]", {
            // Gallery options
        });
    }

    // ===========================================
    // Smooth Scroll for Anchor Links
    // ===========================================
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');

            // Skip if it's just "#"
            if (targetId === '#') return;

            const target = document.querySelector(targetId);

            if (target) {
                e.preventDefault();

                // Get navbar height for offset
                const navbarHeight = navbar ? navbar.offsetHeight : 0;
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // ===========================================
    // Mobile menu navigation handler
    // ===========================================
    const offcanvasEl = document.getElementById('mobileMenu');
    if (offcanvasEl) {
        const mobileLinks = offcanvasEl.querySelectorAll('.mobile-nav-link');

        mobileLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                const href = this.getAttribute('href');
                const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);

                if (offcanvas) {
                    // Close offcanvas first, then navigate
                    offcanvasEl.addEventListener('hidden.bs.offcanvas', function handler() {
                        offcanvasEl.removeEventListener('hidden.bs.offcanvas', handler);
                        window.location.href = href;
                    });
                    offcanvas.hide();
                } else {
                    // Fallback - just navigate
                    window.location.href = href;
                }
            });
        });
    }

});
